import styled from "styled-components";
import AppWrapper from "../../../../layout/AppWrapper";
import Title from "../../../../utils/Title";
import TopSellingStock from "../../dashboard/TopSellingStock";
import { useUserContext } from "../../../../context/user_context";
import { useFetch } from "../../../../api/useFetch";
import { useEffect } from "react";
import BestSellingCategory from "../BestSellingCategory";
import OverviewChart from "../OverviewChart";
import BackButton from "../../../BackButton";
import StoreReportOverview from "./StoreReportOverview";
import CustomChart from "../../../../utils/CustomChart";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useReportContext } from "../../../../context/report_context";
import FilterReport from "../FilterReport";
import TopSellingProduct from "../TopSellingProduct";
import BestSellingProduct from "../BestSellingProduct";



const StoreReport = () => {
  const { btoken, stoken } = useUserContext();

  const params = useParams();
  const { id: storeToken } = params;
  let data = {
    btoken, stoken
  };


  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');

  const getCurrentMonthYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // add leading zero
    return `${ year }-${ month }`;
  };

  const [key, setkey] = useState('');

  useEffect(() => {
    getCurrentMonthYear();
    setkey(getCurrentMonthYear());
    if (key) {
      const [yr, mo] = key.split("-");
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const monthIndex = parseInt(mo, 10) - 1;

      setYear(yr);
      setMonth(monthNames[monthIndex]);
    }
  }, [key]);

  const { handleStoreFilter, storeChart, storeBestSell, storeTopSell, isFetching } = useReportContext();

  useEffect(() => {
    handleStoreFilter({ storeToken, month, year });
  }, [month, year]);

  const filterData = { year, month, setMonth, setYear };

  return (
    <AppWrapper
      pagename={'reports'}
    >
      <StyledStoreReport>
        <Title title={"Store Report"} btnName={""} />

        <BackButton />

        <FilterReport
          {...filterData}
        />

        <section className="row">
          <div className="col-md-8">
            <StoreReportOverview />
          </div>
          <div className="mt-4 mt-md-0 col-md-4">
            <BestSellingCategory />
          </div>
        </section>

        <section className="my-3">
          <CustomChart
            title={'Overview Chart'}
            chartData={storeChart}
            loading={isFetching}
          />
        </section>

        <section className="gap-3 gap-md-0 my-3 row">
          <div className="col-md-6">
            <TopSellingProduct
              storeTopSell={storeTopSell}
            />
          </div>
          <div className="col-md-6">
            <BestSellingProduct
              storeBestSell={storeBestSell}
            />
          </div>

        </section>
      </StyledStoreReport>
    </AppWrapper>
  );
};

export default StoreReport;

const StyledStoreReport = styled.div`
      

`;